import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from '@heroicons/react/24/outline';
import Button from '../Button';

interface PricingPlan {
  name: string;
  description: string;
  monthlyPrice: number;
  yearlyPrice: number;
  features: string[];
  accentColor: string;
  popular: boolean;
}

interface PricingCardProps {
  plan: PricingPlan;
  isYearly: boolean;
  className?: string;
}

const PricingCard: React.FC<PricingCardProps> = ({ plan, isYearly, className = '' }) => {
  const price = isYearly ? plan.yearlyPrice : plan.monthlyPrice;
  
  return (
    <motion.div
      whileHover={{ y: -8 }}
      transition={{ duration: 0.3 }}
      className={`
        relative bg-white rounded-2xl shadow-xl overflow-hidden
        border border-gray-100 ${className}
      `}
    >
      {plan.popular && (
        <div className="absolute top-0 right-0">
          <div className={`${plan.accentColor} text-white px-4 py-1 rounded-bl-lg text-sm font-medium`}>
            Most Popular
          </div>
        </div>
      )}

      <div className="p-8">
        <h3 className="text-xl font-semibold text-gray-900 mb-2">{plan.name}</h3>
        <p className="text-gray-600 mb-6">{plan.description}</p>
        
        <div className="mb-8">
          <div className="flex items-baseline">
            <span className="text-4xl font-bold text-gray-900">${price}</span>
            <span className="ml-2 text-gray-600">/{isYearly ? 'year' : 'month'}</span>
          </div>
          {isYearly && (
            <p className="mt-2 text-sm text-green-600">
              Save ${plan.monthlyPrice * 2} annually
            </p>
          )}
        </div>

        <Button
          variant={plan.popular ? 'primary' : 'outline'}
          className="w-full mb-8"
          onClick={() => {}}
        >
          Get started
        </Button>

        <div className="space-y-4">
          {plan.features.map((feature, index) => (
            <div key={index} className="flex items-center">
              <CheckIcon className={`h-5 w-5 ${plan.popular ? 'text-airbnb-red' : 'text-blue-500'} mr-3`} />
              <span className="text-gray-600">{feature}</span>
            </div>
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default PricingCard;